// extracted by mini-css-extract-plugin
var _1 = "BuildingFormFields-moduleactions__u7JKZ FormActions-moduleFormActions__WNNEs";
var _2 = "BuildingFormFields-modulecontent__k1mTb Content-modulecontent__lhnnP";
var _3 = "BuildingFormFields-modulefieldWrapper__IKyhN";
var _4 = "BuildingFormFields-moduleformFields__bl1NR FormFieldsContainer-moduleFormFieldsContainer__u1JJu";
export { _1 as "actions", _2 as "content", _3 as "fieldWrapper", _4 as "formFields" }
